import { DocStep, ValidationTokenResponse } from './types';
import GenericSignStep from './steps/GenericSignStep';
import EmployeeChildcareTuitionStep from './steps/EmployeeChildcareTuitionStep';
import LaptopContractStep from './steps/LaptopContractStep';
import CompletedStepView from './components/CompletedStepView';
import W4Step from './steps/W4Step';
import I9Step from './steps/I9Step';
import I9SpanishStep from './steps/I9SpanishStep';
import IT2104Step from './steps/IT2104Step';
import NC4Step from './steps/NC4Step';
import IS54Step from './steps/IS54Step';
import BankAccountStep from './steps/BankAccountStep';
import PreEmploymentPersonalStep from './steps/PreEmploymentPersonalStep';
import PreEmploymentEmergencyStep from './steps/PreEmploymentEmergencyStep';
import PreEmploymentEducationStep from './steps/PreEmploymentEducationStep';
import PreEmploymentQuestionsStep from './steps/PreEmploymentQuestionsStep';
import PreEmploymentReferencesStep from './steps/PreEmploymentReferencesStep';
import PreEmploymentHistoryStep from './steps/PreEmploymentHistoryStep';
import ReviewStep from './ReviewStep';

export interface StepRendererProps {
  step: DocStep;
  steps: DocStep[];
  stepIndex: number;
  totalSteps: number;
  completedSteps: number;
  token: string;
  tokenData: ValidationTokenResponse;
  application: any;
  bankingAccounts: any[];
  uploadedDocuments: any[];
  draft: any;
  saveDraft: (value: unknown) => void;
  clearDraft: () => void;
  onBack: () => void;
  onPrevious?: () => void;
  onNext: () => void;
  onSaveLater: () => void;
  onJumpTo: (stepId: string) => void;
  onComplete: () => void;
}

const StepRenderer = (props: StepRendererProps) => {
  const { step } = props;

  if (step.status === 'completed' && step.kind !== 'REVIEW') {
    return <CompletedStepView {...props} />;
  }

  switch (step.kind) {
    case 'W4':
      return <W4Step {...props} />;
    case 'I9_ENGLISH':
      return <I9Step {...props} />;
    case 'I9_SPANISH':
      return <I9SpanishStep {...props} />;
    case 'IT2104':
      return <IT2104Step {...props} />;
    case 'NC4':
      return <NC4Step {...props} />;
    case 'IS54':
      return <IS54Step {...props} />;
    case 'BANK_ACCOUNT':
      return <BankAccountStep {...props} />;
    case 'HIRING_AGREEMENT':
      return <GenericSignStep {...props} />;
    case 'EMPLOYEE_CHILDCARE_TUITION':
      return <EmployeeChildcareTuitionStep {...props} />;
    case 'LAPTOP_CONTRACT':
      return <LaptopContractStep {...props} />;
    case 'PRE_EMPLOYMENT_PERSONAL':
      return <PreEmploymentPersonalStep {...props} />;
    case 'PRE_EMPLOYMENT_EMERGENCY':
      return <PreEmploymentEmergencyStep {...props} />;
    case 'PRE_EMPLOYMENT_EDUCATION':
      return <PreEmploymentEducationStep {...props} />;
    case 'PRE_EMPLOYMENT_QUESTIONS':
      return <PreEmploymentQuestionsStep {...props} />;
    case 'PRE_EMPLOYMENT_REFERENCES':
      return <PreEmploymentReferencesStep {...props} />;
    case 'PRE_EMPLOYMENT_HISTORY':
      return <PreEmploymentHistoryStep {...props} />;
    case 'REVIEW':
      return <ReviewStep {...props} />;
    default:
      return null;
  }
};

export default StepRenderer;
